// package imports
import { useTheme } from '@mui/material/styles';

// local imports
import { parseMessage } from './message-parser';
import { flashDotStyles } from './styles';
import { isSafeUrl } from 'services/parseUtils/parseUrl';

const AssistantMessage = ({ message, index, handleFollowUp: _handleFollowUp }) => {
  const theme = useTheme();
  const parsedMessage = parseMessage(message);

  const parseCitation = (content) => {
    const parts = content.split(' ');
    if (
      parts.length === 3 &&
      parseInt(parts[2], 10) !== NaN &&
      parseInt(parts[2], 10) > 0
    ) {
      return (
        <>
          <a
            style={{ textDecoration: 'underline' }}
            href={isSafeUrl(parts[0]) ? encodeURI(parts[0]) : '#'}
            target="_blank"
            rel="noopener noreferrer"
          >
            {parts[0]}
          </a>
          <span> ({`${parts[1]} ${parts[2]}`})</span>
        </>
      );
    } else {
      return (
        <a
          style={{ textDecoration: 'underline' }}
          href={isSafeUrl(parts[0]) ? encodeURI(parts[0]) : '#'}
          target="_blank"
          rel="noopener noreferrer"
        >
          {parts[0]}
        </a>
      );
    }
  };

  return (
    <div
      id={`assistant-message-${index}`}
      key={index}
      className="flex justify-start flex-wrap flex-col my-4"
    >
      <div className="flex flex-row bg-white text-gray-900 rounded-md p-4">
        <div className="p-4 ">
          {!parsedMessage.content && (
            <div className="ml-4 mr-r mt-1">
              <style>{flashDotStyles(theme)}</style>
              <div className="dot-flashing"></div>
            </div>
          )}
          {/* <div
            dangerouslySetInnerHTML={{ __html: parsedMessage.content }}
          ></div> */}
          {parsedMessage.content && parsedMessage.content}
          <div
            className={`${parsedMessage?.citations?.length > 0 ? 'flex' : 'hidden'} flex-col`}
          >
            <div className="mt-4">Citations:</div>
            <ol
              type="1"
              role="list"
              style={{ listStylePosition: 'inside', listStyleType: 'decimal' }}
            >
              {parsedMessage?.citations?.map((citation, index) => (
                <li key={index}>{parseCitation(citation)}</li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssistantMessage;
